module.exports = __webpack_public_path__ + "media/images/lang-fcdbb112.svg";